<template lang="pug">
    .calendarTitle
        router-link.logo(to="/")
            img(src="@/assets/img/logo.png")
        .content
            router-link.content-description(to="/")
              img.white.forDesktop(:src="require('@/assets/img/calendarLogo/logo_white_'+$i18n.locale+'.png')")
              img.black.forDesktop(:src="require('@/assets/img/calendarLogo/logo_black_'+$i18n.locale+'.png')")
              img.white.forMobile_or_p(:src="require('@/assets/img/calendarLogo/logo_white-mobile_'+$i18n.locale+'.png')")
              img.black.forMobile_or_p(:src="require('@/assets/img/calendarLogo/logo_white-mobile_'+$i18n.locale+'.png')")
              h3 {{$t('home.logoText')}}
            slot
</template>

<script>
    export default {
        name: "CalendarTitle",
    }
</script>

<style scoped lang="scss">
    .calendarTitle{
        display: flex;
        align-items: flex-start;
        &.disabled{
            .logo, .content-description{
                pointer-events: none;
            }
        }
    }
    .logo img {
        width: 25.3rem;
    }

    .content {
        width: 100%;
        margin-top: 1rem;
        margin-left: -5.1rem;
        padding-top: 5.5rem;
        .content-description{
            display: inline-block;
            img {
                width: 44.5vw;
                max-width: 53.4rem;
                margin-bottom: 0.5rem;
                &.black{
                    display: none;
                }
            }
        }

        h3 {
            margin-bottom: 1.1rem;
            font-size: 2rem;
            color: #fff;
        }
    }
    .calendarTitle.black{
        .content{
            .content-description img{
                &.white{
                    display: none;
                }
                &.black{
                    display: inline-block;
                }
            }
            h3{
                color: #000;
            }
        }
    }
    .calendarTitle.small{
        .logo img{
            width: 11.4rem;
        }
        .content{
            margin-left: -2.35rem;
            padding-top: 2rem;
            .content-description img{
                max-width: 23.5rem;
                margin-bottom: 0.1rem;
            }
            h3{
                font-size: 0.885rem;
            }
        }
    }
    @include mobile_or_P{
        .calendarTitle{
            position: relative;
            z-index: 1;
            flex-direction: column;
        }
        .calendarTitle, .calendarTitle.small{
            .logo img{
                width: 13.7rem;
                margin: 1.4rem 1.8rem;
            }
            .content{
                padding-top: 0;
                margin-top: -10.5rem;
                /*margin-top: 0.9rem;*/
                /*margin-left: -6.3rem;*/
                margin-left: 0;

                .content-description {
                  padding-left: 11rem;
                }

                .content-description img{
                    width: 11.75rem;
                    max-width: 100%;
                    margin-bottom: 0.85rem;
                }
                h3{
                    max-width: 12rem;
                    margin-bottom: 2.45rem;
                    font-size: 1.2em;
                    line-height: 1.25;
                }
                /*.app_btn{
                    position: absolute;
                    top: 100%;
                    left: 52%;
                    transform: translateX(-50%);
                }*/
            }
        }
        .calendarTitle.small{
            .content{
                padding-top: 5.5rem;
            }
        }
    }
</style>
